import { render, staticRenderFns } from "./ModelSpecForm.vue?vue&type=template&id=374db568&scoped=true"
import script from "./ModelSpecForm.vue?vue&type=script&lang=js"
export * from "./ModelSpecForm.vue?vue&type=script&lang=js"
import style0 from "./ModelSpecForm.vue?vue&type=style&index=0&id=374db568&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374db568",
  null
  
)

export default component.exports